// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkUpgradePage_wrapper__wwxSp","closeButton":"WorkUpgradePage_closeButton__73TmJ"};